import React from 'react';
import styled from 'styled-components';
import {
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

export const QuickDrawer = ({
  open,
  onClose,
  children,
  title = 'Quick View',
  width = '450px'
}) => {
  if (!open) return null;
  return <Drawer width={width}>
    <Header>
      <span>{title}</span>
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Header>
    {children}
  </Drawer>;
};

const Drawer = styled.div`
  position: fixed;
  z-index: 101;
  top: 0;
  right: 0;
  height: 100vh;
  width: ${({ width }) => width};
  background-color: #ffffff;
  border-left: solid 1px #f0f0f0;
  box-shadow: -5px 1px 14px -3px rgba(0,0,0,0.22);
  transition: right 0.25s ease-out;
  overflow-y: auto;
`;

const Header = styled.div`
  width: 100%;
  height: 47px;
  display: flex;
  color: #0c7eac;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #ebf0f6;
  span {
    color: #99ACC2;
    font-size: 18px;
    font-weight: 700;
    &.MuiIconButton-label {
      color: #0c7eac;
    }
  }
`;